export const nearbyUnits = {
  'Nearby clinics': 'Clínicas cercanas',
  'Nearest clinic': 'Clínica más cercana',
  'Other nearby clinics': 'Otras clínicas cercanas',
  'See all clinics': 'Ver todas las clínicas',
  'The clinic at {{name}} is near you':
    'La clínica en {{name}} está muy cerca de usted',
  'These are other units that are near you':
    'Estas son otras unidades que están cerca de usted',
  'We could not find any units near your location':
    'No pudimos encontrar ninguna unidad cercana a su ubicación',
};
